import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProBadge = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 210 122",
	style: { enableBackground: "new 0 0 210 122" },
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", {
			type: "text/css",
			children: "\n	.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#61B2DF;}\n	.st1{fill:#FFFFFF;}\n"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M202.9,122H7.1c-4,0-7.2-3.2-7.2-7.2V7.2c0-4,3.2-7.2,7.2-7.2h195.7c4,0,7.2,3.2,7.2,7.2v107.6 C210.1,118.8,206.8,122,202.9,122z"
		}),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				className: "st1",
				d: "M45.8,87V24.8h28c2.9,0,5.4,0.5,7.7,1.4c2.3,0.9,4.2,2.2,5.8,3.9c1.6,1.7,2.8,3.7,3.7,6.1 c0.8,2.4,1.2,5,1.2,7.8c0,2.9-0.4,5.5-1.2,7.9c-0.8,2.3-2,4.4-3.7,6.1c-1.6,1.7-3.5,3-5.8,3.9c-2.3,0.9-4.9,1.4-7.7,1.4H57.6V87 H45.8z M57.6,53.1h15.1c2.3,0,4-0.6,5.3-1.8c1.3-1.2,2-3,2-5.2V42c0-2.3-0.7-4-2-5.2C76.8,35.6,75,35,72.8,35H57.6V53.1z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st1",
				d: "M98.7,87V40.5h11.4v9.6h0.4c0.3-1.2,0.8-2.5,1.4-3.6c0.6-1.2,1.4-2.2,2.5-3.1c1-0.9,2.2-1.6,3.6-2.1 c1.4-0.5,3-0.8,4.9-0.8h2.5v10.8h-3.6c-3.9,0-6.8,0.6-8.7,1.7c-2,1.1-2.9,3-2.9,5.5V87H98.7z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st1",
				d: "M149,88c-3.3,0-6.3-0.6-9-1.7c-2.6-1.1-4.9-2.8-6.8-4.9c-1.9-2.1-3.3-4.7-4.3-7.7c-1-3-1.5-6.4-1.5-10.1 c0-3.7,0.5-7.1,1.5-10.1c1-3,2.5-5.5,4.3-7.6c1.9-2.1,4.1-3.7,6.8-4.9c2.6-1.1,5.6-1.7,9-1.7c3.3,0,6.3,0.6,9,1.7 c2.7,1.1,4.9,2.7,6.8,4.9c1.9,2.1,3.3,4.6,4.3,7.6c1,3,1.5,6.3,1.5,10.1c0,3.7-0.5,7.1-1.5,10.1c-1,3-2.5,5.6-4.3,7.7 c-1.9,2.1-4.1,3.8-6.8,4.9C155.3,87.5,152.3,88,149,88z M149,78.9c3,0,5.4-0.9,7.1-2.8c1.7-1.8,2.6-4.5,2.6-8.1v-8.6 c0-3.5-0.9-6.2-2.6-8c-1.7-1.8-4.1-2.8-7.1-2.8c-3,0-5.3,0.9-7,2.8c-1.7,1.8-2.6,4.5-2.6,8V68c0,3.6,0.9,6.3,2.6,8.1 C143.7,77.9,146,78.9,149,78.9z"
			})
		] })
	]
});
export default SvgProBadge;
